(function() {
  if (window.__t4sCollectionDescriptionToggleInitialized) {
    return;
  }

  window.__t4sCollectionDescriptionToggleInitialized = true;

  var DESCRIPTION_SELECTOR = '[data-collection-description]';
  var CONTENT_SELECTOR = '[data-collection-description-content]';
  var TOGGLE_SELECTOR = '[data-collection-description-toggle]';
  var SHOW_MORE_LABEL = 'Show more';
  var SHOW_LESS_LABEL = 'Show less';

  function setExpanded(container, expanded) {
    var content = container.querySelector(CONTENT_SELECTOR);
    var toggle = container.querySelector(TOGGLE_SELECTOR);

    if (!content || !toggle) {
      return;
    }

    container.classList.toggle('is-expanded', expanded);
    content.classList.toggle('is-collapsed', !expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.setAttribute('aria-label', expanded ? SHOW_LESS_LABEL : SHOW_MORE_LABEL);
  }

  function syncState(container) {
    var content = container.querySelector(CONTENT_SELECTOR);
    var toggle = container.querySelector(TOGGLE_SELECTOR);

    if (!content || !toggle) {
      return;
    }

    content.classList.add('is-collapsed');
    var hasOverflow = content.scrollHeight > content.clientHeight + 1;

    if (hasOverflow) {
      container.classList.add('is-collapsible');
      toggle.hidden = false;
      setExpanded(container, container.classList.contains('is-expanded'));
      return;
    }

    container.classList.remove('is-collapsible');
    container.classList.remove('is-expanded');
    content.classList.remove('is-collapsed');
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', SHOW_MORE_LABEL);
  }

  function bindToggle(container) {
    var toggle = container.querySelector(TOGGLE_SELECTOR);

    if (!toggle || container.dataset.descriptionToggleBound === 'true') {
      return;
    }

    toggle.addEventListener('click', function() {
      setExpanded(container, !container.classList.contains('is-expanded'));
    });

    container.dataset.descriptionToggleBound = 'true';
  }

  function init(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll(DESCRIPTION_SELECTOR);

    for (var i = 0; i < containers.length; i++) {
      bindToggle(containers[i]);
      syncState(containers[i]);
    }
  }

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function() {
      init(document);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('load', function() {
    init(document);
  });

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
